/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import axios from "axios";

import { styled } from "@mui/material/styles";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";

import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import { Block } from "notiflix/build/notiflix-block-aio";

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDAvatar from "components/MDAvatar";
import { CustomSelect } from "components/CustomSelect";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

// components
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DownloadingIcon from '@mui/icons-material/Downloading';

import Tooltip from "@mui/material/Tooltip";

import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";

// queries
import {
  useGetAllServerProductsQuotesByCountryIdQuery,
  useGetServerProductByIdQuery,
  usePostServerProductMutation,
  usePutServerProductMutation,
  useDeleteServerProductQuoteMutation
} from "services/products";

import {
  useGetWoocommerceSiteCategoriesMutation,
  usePostCategoryNameMutation,
  useGetAllResellerProductCategoriesQuery,
  usePutCategoryNameMutation,
  useLazyGetAllResellerProductCategoriesQuery,
} from "services/categories";

import {
  useGetAllUrlsByCountryIdQuery,
  useLazyGetAllUrlsByCountryIdQuery,
} from "services/countries";

// import { useGetAllProductsFromStoreUrlQuery } from "services/store";

import {
  globalCountry,
  selectedCountryURL,
  setSelectedCountryURL,
  resetSelectedCountryURL,
} from "store/entities/countries";

import {
  setGlobalLoader,
  setGlobalLoaderMessage,
  resetGlobalLoader,
  loaderStatus,
  globalLoaderMessage,
} from "store/ui/loader";

import { resetStockId, getCurrentStockId } from "store/entities/stockNotifications";

import { actions as tableActions } from "store/ui/table";

import Alert from "components/CustomAlert";

import CircularProgress from "@mui/material/CircularProgress";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import noPreview from "assets/images/no-preview.png";

import EditInventoryDialog from "./EditServerProductQuoteDialog";

import { tables } from "utils/constants";
import {
  removeLocalStorageItemsWithPrefix,
  imageSrcDecoder,
  replaceHTMLEntityAnd,
  removeUnecessaryFields
} from "utils/helperFunctions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function ServerProducts() {

  const selectedCountry = useSelector(globalCountry);

  const [imageLoading, setImageLoading] = useState(true);

  const navigate = useHistory();

  const dispatch = useDispatch();

  const {
    data: productList = [],
    isLoading,
    isSuccess,
  } = useGetAllServerProductsQuotesByCountryIdQuery(selectedCountry.id);

  const [deleteProductQuote, result] = useDeleteServerProductQuoteMutation();

  useEffect(() => {
    isLoading ? Loading.dots({ svgColor: "rgba(159, 3, 3, 0.8)" })
      : Loading.remove(500);
  }, [isLoading]);
  
  const deleteRecord = async (id) => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });
    try {
      deleteProductQuote(id)
        .then((response) => {
          if (response) {
            Notify.success("Succefully deleted!");
          } else {
            Notify.failure("Something went wrong!");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    } finally {
      Loading.remove(500);
    }
  };

  return (
    <Card>
      <CardHeader
        // avatar={<AccountCircleIcon fontSize="large" color="dark" />}
        title={<MDTypography color="info">Server Product Quotes</MDTypography>}
        // action={
        //   <MDBox display="flex" alignItems="center">
        //     <MDButton
        //       variant="gradient"
        //       color="info"
        //       onClick={() => navigate.push(`/user/add-server-product`)}
        //     >
        //       Add New
        //     </MDButton>
        //   </MDBox>
        // }
      />
      <CardContent id="wrapper">
        <MDBox id="tableWrapper">
          <DataTable
              id={tables.SERVER_PRODUCTS}
              // headerActions={
              //   <MDBox>
                  
              //   </MDBox>
              // }
              columns={[
                // {
                //   Header: "Image",
                //   accessor: "image",
                //   Cell: ({ row: { original } }) => (
                //     <MDBox display="flex" alignItems="center" lineHeight={1}>
                //       {imageLoading && (
                //         <CircularProgress
                //           color="primary"
                //           sx={{
                //             width: "10px",
                //             height: "10px",
                //           }}
                //           size="small"
                //         />
                //       )}
                //       <MDAvatar
                //         src={
                //           original.images &&
                //             original.images.length > 0 &&
                //             original.images[0] &&
                //             original.images[0].url
                //             ? imageSrcDecoder(original.images[0].url)
                //             : noPreview
                //         }
                //         name={original.name}
                //         onLoad={() => setImageLoading(false)}
                //         size="md"
                //       />
                //     </MDBox>
                //   ),
                // },
                {
                  Header: "Product Name",
                  accessor: "productName",
                  Cell: ({ row: { original } }) => <MDBox>
                        <MDBox>ID: {original.productId}</MDBox>
                        <MDBox sx={{ fontWeight: 600, fontSize: "11px" }}>
                          {original.productName}
                        </MDBox>
                      </MDBox>,
                },
                {
                  Header: "Reseller Name",
                  accessor: "resellerId",
                  Cell: ({ row: { original } }) => <MDBox>
                        <MDBox>{original.resellerName}</MDBox>
                        <MDBox sx={{ fontWeight: 600, fontSize: "11px" }}>
                          {original.resellerEmail}
                        </MDBox>
                      </MDBox>,
                },
                {
                  Header: "BDM Name",
                  accessor: "bdmId",
                  Cell: ({ row: { original } }) => <MDBox>
                        <MDBox>ID: {original.bdmId}</MDBox>
                        <MDBox sx={{ fontWeight: 600, fontSize: "11px" }}>
                          {original.bdm}
                        </MDBox>
                      </MDBox>,
                },
                {
                  Header: "Status",
                  accessor: "status",
                },
                {
                  Header: "Options",
                  accessor: "options",
                  Cell: ({ row: { original } }) => (original.options.length),
                },
                {
                  Header: "Est Price",
                  accessor: "estimatedPrice",
                  Cell: ({ row: { original } }) => (`${selectedCountry.currency} ${original.estimatedPrice}`),
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  disableSortBy: true,
                  disableFilters: true,
                  show: true,
                  align: "right",
                  // eslint-disable-next-line react/display-name
                  Cell: ({ row: { original } }) => (
                    <div className="actions-right">
                      <EditInventoryDialog
                        initialData={original}
                        selectedCountry={selectedCountry}
                      />
                      {original.type != "variable" && (
                        <Tooltip title="Delete" sx={{ ml: 1 }} placement="top">
                          <IconButton
                            aria-label="view"
                            size="small"
                            onClick={() => {
                              Confirm.show(
                                `Please Confirm`,
                                "Are you sure you want to delete?",
                                "Yes",
                                "No",
                                () => {
                                  deleteRecord(original.id);
                                },
                                () => { },
                                {}
                              );
                            }}
                          >
                            <Close color="error" fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  ),
                },
              ]}
              data={productList}
              isSorted={true}
              entriesPerPage={false}
              showTotalEntries={false}
              hideColumnSelection={false}
              noEndBorder
              canSearch
            // actionButton={
            //   <MDButton
            //     variant="gradient"
            //     color="primary"
            //     sx={{ ml: 2 }}
            //     onClick={handleClickOpen}
            //     disabled={urlsByCountryId.length == 0}
            //   >
            //     Add Stock
            //   </MDButton>
            // }
            />
        </MDBox>
      </CardContent>
    </Card>
  );
}

export default ServerProducts;
